export const DEFAULT_PROMPTS = [
  {
    label: "Shopify Liquid filter performance",
    prompt:
      "Practical patterns for fast collection filtering in Shopify Liquid: when to do it server-side vs client-side, common pitfalls with metafields and tags, and a real before/after benchmark.",
  },
  {
    label: "Headless Shopify (Hydrogen) — real-world traps",
    prompt:
      "Lessons from running a headless Shopify (Hydrogen) storefront in production. SEO, cart, checkout handoff, image pipelines, and where headless is overkill.",
  },
  {
    label: "Core Web Vitals for Shopify in 2026",
    prompt:
      "A pragmatic Core Web Vitals checklist for Shopify themes in 2026 — LCP image strategy, JS budget, app block hygiene, and what Shopify's new Performance metrics actually mean.",
  },
  {
    label: "Shopify App development — webhooks + queues",
    prompt:
      "How to design a reliable Shopify public app: webhooks, retries, idempotent processing with a queue (BullMQ / Redis), and how to survive Shopify's rate limits.",
  },
  {
    label: "Laravel + Elasticsearch e-commerce search",
    prompt:
      "Building a fast, typo-tolerant product search with Laravel and Elasticsearch — index design, synonyms, multi-language analyzer, faceted filters, and reindex strategies without downtime.",
  },
  {
    label: "Node.js — high-volume order processing",
    prompt:
      "Designing a Node.js worker pipeline that processes thousands of orders/min reliably: backpressure, idempotency keys, dead-letter queues, observability, and graceful deploys.",
  },
  {
    label: "React 19 / Server Components in production",
    prompt:
      "Honest field notes from running React Server Components in production — boundaries, data fetching patterns, caching, and the tradeoffs nobody talks about.",
  },
  {
    label: "Schema markup that actually moves SEO",
    prompt:
      "Schema markup for e-commerce that actually moves rankings and CTR: Product, Offer, AggregateRating, BreadcrumbList, FAQ — with concrete examples and common Search Console errors.",
  },
  {
    label: "Freelancing globally from NYC",
    prompt:
      "Notes on freelancing globally as a developer based in New York — pricing in USD, contracts, async-first workflow with international clients, payment rails, and how to find better clients without job boards.",
  },
  {
    label: "Shopify Plus checkout extensibility migration",
    prompt:
      "Migrating from checkout.liquid to Shopify Plus checkout extensibility: what breaks, what's better, the order of operations, and a realistic rollout plan with rollback.",
  },
  {
    label: "MongoDB vs MySQL for e-commerce",
    prompt:
      "MongoDB vs MySQL for e-commerce backends — when each one wins, hybrid setups, indexing patterns for product catalogs, and a calm answer to 'which should I pick?'.",
  },
  {
    label: "AI-generated product descriptions, done right",
    prompt:
      "Using LLMs to scale product descriptions for e-commerce without sounding generic: prompt structure, brand voice priming, deduplication, human review loop, and SEO guardrails.",
  },
];
